import { Component } from '@angular/core'
import {
	IMC_CLASSIFICATION,
	IMC_CLASSIFICATION_SOURCE,
	ImcRange,
} from './imc-classification'

@Component({
	selector: 'app-imc-table',
	templateUrl: './imc-table.component.html',
	styleUrls: ['./imc-table.component.scss'],
})
export class ImcTableComponent {
	ranges: ImcRange[] = IMC_CLASSIFICATION
	source: string = IMC_CLASSIFICATION_SOURCE
}
